export default __webpack_public_path__ + "media/images/elephant_ui_plane-a8b4efef8386bd74d213e0235bc1b7ab.svg";